import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase web configuration identifies this public client; it is not a secret.
const firebaseConfig = {
  apiKey: 'AIzaSyBMvNvphTW-dt5QwWuqrU_DyNIVoJlT68c',
  authDomain: 'delta-pools-accounts.firebaseapp.com',
  projectId: 'delta-pools-accounts',
  storageBucket: 'delta-pools-accounts.firebasestorage.app',
  messagingSenderId: '494163931835',
  appId: '1:494163931835:web:69bc04dbfbf0759e81af9',
  measurementId: 'G-WC8PZC1YG4',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });
export const INITIAL_ADMIN_EMAIL = 'xllmngt.acc@gmail.com';
export const INITIAL_TENANT_ID = 'delta-pools';
